'use strict';

require('./KayleeService');
require('./RoomService');
require('./ThemeService');
var log = require('../../log/Log').channel('WallpaperController');
var sutl = require('../../sutl/Sutl');

angular.module('inara').controller('WallpaperController', WallpaperController);

WallpaperController.$inject = ['$rootScope', '$scope', '$state', 'RoomService', 
                               'KayleeService', 'ThemeService', '$window', 
                               '$timeout', 'gettextCatalog', 'RoomPasswordService'];

function WallpaperController($rootScope, $scope, $state, RoomService, 
                             KayleeService, ThemeService, $window, 
                             $timeout, gettextCatalog, RoomPasswordService) {
    var vm = this;
    var room = null;
    var site = null;
    var powerOffTimestamp = null;
    var backgroundColor = '';
    var isPoweringOff = false;
    var poweringOffMessageDelay = 2500; // ms
    var poweredOffMessageDelay = 1500; // ms
    var powerOffMessage = '';
    var powerOffTimeout = null;

    log.info('initializing');

    $scope.$on('$destroy', onDestroy);
    $scope.$on('$stateChangeSuccess', onStateChanged);
    RoomService.onOnlineChanged(onRoomServiceOnlineChanged);
    RoomService.onStateChanged(onRoomStateChanged);

    vm.showProgressSpinner = function() {
        return ThemeService.isThemeCompiling() || isPoweringOff;
    };

    vm.getProgressMessage = function() {
        if (ThemeService.isThemeCompiling()) {
            /// Status message displayed while processing visual theme
            return gettextCatalog.getString('Processing visual theme...');
        } else if (isPoweringOff) {
            return powerOffMessage;
        }
        return '';
    };

    vm.supportsClickBlock = function() {
        return angular.isDefined($window.cordova);
    };

    vm.getBackgroundStyle = function() {
        var backgroundStyle = {};
        // TODO: site is null until RoomService is online
        if ((vm.isControl || vm.isLocked) &&
            site !== null &&
            site.hasOwnProperty('visualTheme') &&
            site.visualTheme !== null) {
            var backgroundUrl = ThemeService.getImageUrl('backgroundImage');
            
            if (site.visualTheme.hasOwnProperty('backgroundImage') &&
                site.visualTheme.backgroundImage.key !== null &&
                backgroundUrl !== null) {
                backgroundStyle['background-image'] = 'url(\'' + backgroundUrl + '\')';
            } else if (site.visualTheme.hasOwnProperty('colorBackground')) {
                // hide default background image to reveal background color
                backgroundStyle['background-image'] = 'url(\'\')';
            }

            backgroundStyle['background-color'] = backgroundColor;
        }
        return backgroundStyle;
    };

    vm.onToggleUiPreviewBanner = function($event) {
        if (process.env.appEnv === 'browser') {
            var user = KayleeService.getUser();
            if (user !== null) {
                user.$loaded().then(function() {
                    if (user.hasOwnProperty('privileges') &&
                        user.privileges.developer === true &&
                        $event.key === 'P' &&
                        $event.ctrlKey === true &&
                        $event.shiftKey === true) {
                        vm.showUiPreviewBanner = !vm.showUiPreviewBanner;
                    }
                });
            }
        }
    };

    vm.isUiPreview = RoomService.isUiPreview;
    vm.showUiPreviewBanner = true;

    function onDestroy() {
        RoomService.offOnlineChanged(onRoomServiceOnlineChanged);
        RoomService.offStateChanged(onRoomStateChanged);
    }

    function onRoomChanged() {
        var newPowerOffTimestamp = sutl.getNode(room, 'states.powerOffTimestamp', -1);

        if (newPowerOffTimestamp !== powerOffTimestamp) {
            if (powerOffTimestamp !== null &&
                newPowerOffTimestamp !== -1 &&
                (vm.isControl || vm.isInfo)) {
                onRoomPowerOff();
            }
            powerOffTimestamp = newPowerOffTimestamp;
        }
    }

    function onRoomPowerOff() {
        if (powerOffTimeout === null) {
            isPoweringOff = true;
            /// Status message displayed while room is powering off
            powerOffMessage = gettextCatalog.getString('Room powering off...');
            powerOffTimeout = $timeout(function() {
                /// Status message displayed after room is powered off
                powerOffMessage = gettextCatalog.getString('Room powered off');
                powerOffTimeout = $timeout(function() {
                    powerOffTimeout = null;
                    isPoweringOff = false;
                    $rootScope.$broadcast('IdleTimeout');
                    RoomPasswordService.lock();
                    $rootScope.$broadcast('SleepService', 'sleep');
                }, poweredOffMessageDelay);
            }, poweringOffMessageDelay);
        }
    }

    function onRoomServiceOnlineChanged(online) {
        if (online) {
            room = RoomService.getRoom();
            room.$onChange(onRoomChanged);
            site = KayleeService.getSite(room.siteId);
            site.$onChange(onSiteChanged);
        } else {
            isPoweringOff = false;
            if (room !== null) room.$offChange(onRoomChanged);
            room = null;
            if (site !== null) site.$offChange(onSiteChanged);
            site = null;
        }
    }

    function onRoomStateChanged(state) {
        if (state === 'unpaired') powerOffTimestamp = null;
    }

    function onSiteChanged() {
        if (site.hasOwnProperty('visualTheme')) {
            if (site.visualTheme.hasOwnProperty('colorBackground')) {
                backgroundColor = site.visualTheme.colorBackground;
            }
        }
    }

    function onStateChanged(event, toState, toParams, fromState, fromParams) {
        vm.isStart = $state.is('start');
        vm.isSetup = $state.includes('setup.*');
        vm.isInfo = $state.includes('info.*');
        vm.isFactoryInstall = $state.is('factoryInstall');
        vm.isControl = $state.includes('control.*');
        vm.isLocked = $state.is('roomPassword');
        vm.isUpdate = $state.is('update');
    }
}

module.exports = WallpaperController;
